module.exports = __webpack_public_path__ + "assets/86187aac5e37e7d736d24c1916f8f1fc.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/bet+2.mp3
 ** module id = 319
 ** module chunks = 0
 **/